module.exports = __webpack_public_path__ + "media/src/images/user-groups-128-489f1c7c28c9212cab5e6d68fee8dd66.png";